import {Component, OnInit} from '@angular/core';
import {GlobalLoaderService} from "../../services/global-loader.service";

@Component({
  selector: 'app-global-loader',
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.scss']
})
export class GlobalLoaderComponent implements OnInit {
  isLoading = false

  constructor(
    private globalLoaderService: GlobalLoaderService
  ) {
  }

  ngOnInit() {
    this.globalLoaderService.isLoading$.subscribe( {
      next: (res) => {
        this.isLoading = res;
      }
    })
  }
}
